export default "__VITE_ASSET__DDmyd_TV__"